import React from "react";
import { motion } from "framer-motion";

const BloodPressureGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div>
                <h4 className="font-medium text-[#002B5C] mb-1">اندازه‌گیری اخیر</h4>
                <div className="grid grid-cols-2 gap-3 mb-3">
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#0072CE]">۱۲۰</div>
                        <div className="text-xs text-[#9EA3A9]">سیستولیک (mmHg)</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#0072CE]">۸۰</div>
                        <div className="text-xs text-[#9EA3A9]">دیاستولیک (mmHg)</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#0072CE]">۷۲</div>
                        <div className="text-xs text-[#9EA3A9]">ضربان قلب (BPM)</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#32D74B]">نرمال</div>
                        <div className="text-xs text-[#9EA3A9]">وضعیت</div>
                    </div>
                </div>

                <h4 className="font-medium text-[#002B5C] mb-1">روند هفتگی</h4>
                <div className="h-20 bg-[#ECEFF1] rounded-[16px] p-3 relative shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-[#32D74B]/50 z-10"></div>

                    <div className="relative h-full flex items-end justify-between">
                        {["ش", "ی", "د", "س", "چ", "پ", "ج"].map((day, i) => {
                            const systolic = [118, 122, 120, 125, 119, 121, 120];
                            const diastolic = [78, 82, 80, 83, 79, 81, 80];

                            const systolicHeight = ((systolic[i] - 90) / 60) * 100;
                            const diastolicHeight = ((diastolic[i] - 60) / 40) * 100;

                            return (
                                <div key={i} className="flex flex-col items-center w-8">
                                    <div className="relative w-4 flex flex-col items-center">
                                        <motion.div
                                            className="absolute bottom-0 w-4 bg-[#0072CE] rounded-t-[4px]"
                                            initial={{ height: 0 }}
                                            animate={{ height: `${systolicHeight}%` }}
                                            transition={{
                                                duration: 0.2,
                                                delay: i * 0.05,
                                                ease: [0.4, 0.0, 0.2, 1],
                                            }}
                                        />
                                        <motion.div
                                            className="absolute bottom-0 w-2 left-1 bg-[#00E5FF] rounded-t-[4px]"
                                            initial={{ height: 0 }}
                                            animate={{ height: `${diastolicHeight}%` }}
                                            transition={{
                                                duration: 0.2,
                                                delay: i * 0.05 + 0.1,
                                                ease: [0.4, 0.0, 0.2, 1],
                                            }}
                                        />
                                    </div>
                                    <span className="text-xs text-[#9EA3A9] mt-1">{day}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="flex justify-between text-xs text-[#9EA3A9] mt-1">
                    <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#0072CE] rounded-full mr-1"></div>
                        <span>سیستولیک</span>
                    </div>
                    <div className="flex items-center">
                        <div className="w-2 h-2 bg-[#00E5FF] rounded-full mr-1"></div>
                        <span>دیاستولیک</span>
                    </div>
                </div>

                <div className="mt-4 p-3 bg-[#ECEFF1] rounded-[16px] shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    <h4 className="font-medium text-[#002B5C] mb-1">اطلاعات اندازه‌گیری</h4>
                    <p className="text-sm text-[#4A5568]">اندازه‌گیری با حسگر اپتیکال ساعت هوشمند شما. برای دقت بیشتر، از دستگاه فشارسنج استفاده کنید.</p>
                    <div className="mt-2 text-xs text-[#9EA3A9]">آخرین اندازه‌گیری: امروز ۱۰:۳۰ صبح</div>
                </div>
            </div>
        </div>
    );
};

export default BloodPressureGraph;
